import React from "react";

import "./SenecaSpinner.scss";

type Props = {
  className?: string;
  style?: Record<string, any>;
};

const SenecaSpinner = ({ className, style }: Props) => {
  return (
    <svg
      className={`SenecaSpinner__animation ${className || "SenecaSpinner"}`}
      style={style}
      viewBox="0 0 77 77"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="seneca-logo" transform="translate(10, 11)">
        <path
          className="N"
          d="M28.4771183,22.2480596 C28.1616975,22.2480596 27.8805084,21.9856834 27.8462767,21.6298582 L26.6188252,6.59294947 C26.2471666,2.67647631 27.0112674,0.074280005 28.4771183,0.074280005 C29.9380789,0.074280005 30.7070699,2.68126857 30.3341888,6.59294947 L29.1030696,21.6298582 C29.0737282,21.9856834 28.7925391,22.2480596 28.4771183,22.2480596 Z"
          id="Fill-2"
        />
        <path
          className="S"
          d="M28.4771183,32.679608 C28.7925391,32.679608 29.0737282,32.9419841 29.1079599,33.2966113 L30.3341888,48.3287278 C30.7070699,52.246399 29.9429692,54.8533875 28.4771183,54.8533875 C27.0161576,54.8533875 26.2471666,52.246399 26.6188252,48.3287278 L27.8511669,33.2966113 C27.8805084,32.9419841 28.1616975,32.679608 28.4771183,32.679608 Z"
          id="Fill-3"
        />
        <path
          className="E"
          d="M33.8013724,27.4608386 C33.8013724,27.1565302 34.0691133,26.8809754 34.4273237,26.8486276 L49.7716894,25.6409785 C53.768242,25.280361 56.423645,26.0291514 56.423645,27.4608386 C56.423645,28.8985161 53.768242,29.6473065 49.7716894,29.2818968 L34.4273237,28.0790399 C34.0691133,28.0466922 33.8013724,27.7699393 33.8013724,27.4608386 Z"
          id="Fill-4"
        />
        <path
          className="W"
          d="M23.1528642,27.4608386 C23.1528642,27.7699393 22.8851233,28.0466922 22.5269129,28.0790399 L7.18254711,29.2866891 C3.18477195,29.6473065 0.530591565,28.8985161 0.530591565,27.4608386 C0.530591565,26.0291514 3.18477195,25.280361 7.18254711,25.6409785 L22.5269129,26.8486276 C22.8851233,26.8809754 23.1528642,27.1565302 23.1528642,27.4608386 Z"
          id="Fill-5"
        />
        <path
          className="NE"
          d="M34.4896743,20.1370697 C34.2647231,19.9214181 34.2072627,19.5895542 34.3649731,19.3882794 L41.3665811,10.8197214 C43.1576333,8.55418122 45.0574934,7.74908181 46.0942253,8.76504059 C47.1309572,9.78099937 46.3093961,11.6427917 43.9975328,13.3979564 L35.2537751,20.2592723 C35.0483848,20.4174169 34.7097353,20.3575136 34.4896743,20.1370697 Z"
          id="Fill-6"
        />
        <path
          className="SW"
          d="M21.3141321,33.0486119 C21.5329706,33.2642635 21.5953212,33.5961274 21.4327206,33.7974023 L14.4323351,42.3671583 C12.6461732,44.6315004 10.7402002,45.4365998 9.70469089,44.4218391 C8.67284923,43.4058803 9.49441036,41.5428899 11.8050511,39.7877252 L20.5451411,32.9276074 C20.7554217,32.7682648 21.0891809,32.8293661 21.3141321,33.0486119 Z"
          id="Fill-7"
        />
        <path
          className="SE"
          d="M34.4847841,33.0486119 C34.7097353,32.8341583 35.0434945,32.773057 35.2537751,32.9323996 L43.9926426,39.7877252 C46.3045059,41.5428899 47.1309572,43.4106726 46.0942253,44.4218391 C45.0574934,45.4365998 43.1527431,44.6315004 41.3665811,42.3671583 L34.3649731,33.8021945 C34.203595,33.5961274 34.2647231,33.2642635 34.4847841,33.0486119 Z"
          id="Fill-8"
        />
        <path
          className="NW"
          d="M21.3141321,20.1370697 C21.0940711,20.3527214 20.7554217,20.4138227 20.5451411,20.2544801 L11.8050511,13.3979564 C9.49441036,11.6427917 8.67284923,9.77620711 9.70835857,8.76504059 C10.7402002,7.74908181 12.6461732,8.55418122 14.4372253,10.8197214 L21.4327206,19.3834871 C21.5953212,19.5895542 21.5329706,19.9214181 21.3141321,20.1370697 Z"
          id="Fill-9"
        />
      </g>
    </svg>
  );
};

export default SenecaSpinner;
